import { Button } from "@/components/ui/button";
import { Trash } from "lucide-react";

interface DeleteButtonProps {
  onClick: () => void;
}

export const DeleteButton = ({ onClick }: DeleteButtonProps) => (
  <Button variant="ghost" size="icon" onClick={onClick}>
    <Trash className="h-4 w-4" />
  </Button>
);